// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"642":"03674c88","775":"a4f5ae1b","980":"ddddeb9b"}[chunkId] + ".chunk.css";
};